import { WarningOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { useBomItemIssueDescription } from 'features/BillOfMaterials/components/useBomItemIssueDescription'
import { downloadProjectDeliveryDateEstimation } from 'features/BillOfMaterials/store/asyncActions/downloadProjectDeliveryDateEstimation'
import { IssueDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppDispatch } from 'store/configureStore'

type Props = {
  issue: IssueDto
}

/**
 * handles project level issue code for delivery estimation error
 * @param props
 * @returns
 */
export const DeliveryEstimationNumberOfDaysTodo = (props: Props) => {
  const { getIssueDescription } = useBomItemIssueDescription()
  const dispatch = useAppDispatch()

  const handleClick = () => {
    dispatch(downloadProjectDeliveryDateEstimation())
  }

  return (
    <Button
      component={'li'}
      style={{
        display: 'flex',
        gap: '1em',
      }}
      color="inherit"
      onClick={handleClick}
      startIcon={<WarningOutlined color="warning" />}
    >
      <div>
        <Typography variant="body2">
          {getIssueDescription(props.issue)}
        </Typography>
      </div>
    </Button>
  )
}
